import { ManifestLegProps, ManifestProps, ManifestSSCCProps, TripSheetProps } from '../../../datastore/tripSheets';
import { ReceiptEventPackageProps, SSCCProps } from '../../../datastore/ssccs';
import { ManifestStatus, TripLegStatus } from '../../../common/status';

export interface Manifest {
  id: string;
  tripId: string;
  tripReference: string;
  tripSheetId: string;
  trailerId: string;
  ssccs: ManifestSSCCProps[];
  legId: string;
  status: ManifestStatus;
  ssccsWithAsns: ManifestSSCC[];
  createdAt: string;
  destination: string;
  isDeleted: boolean;
}

export interface ManifestSSCC {
  ssccId: string;
  sscc: ManifestSSCCProps | undefined;
  asns: ReceiptEventPackageProps[];
}

export interface SelectedManifest {
  manifest: Manifest;
  tripDisplayStatus: TripLegStatus;
  ssccStatus: string;
  asnStatus: string;
  tripId: string; // the unique one, not reference id
  legId: string;
}

export interface SelectedManifestSSCC {
  manifest: Manifest;
  tripDisplayStatus: TripLegStatus;
  ssccStatus: string;
  asnStatus: string;
  tripId: string; // the unique one, not reference id
  legId: string;
  ssccId: string;
  sscc: ManifestSSCC;
}

export interface SelectedUnassignedSSCC {
  ssccId: string;
  sscc: SSCCProps | undefined;
  ssccStatus: string;
}

export interface ASNToDelete {
  asnStatus: string;
  asnUniqueId: string;
  tripAsnUniqueId?: string | null;
  asn: ReceiptEventPackageProps;
  priority?: string | null;
  isDuplicate?: boolean;
  priorityShipping?: boolean;
  tripDisplayStatus?: TripLegStatus;
  tripId: string | null; // the unique one, not reference id
  legId: string | null;
  ssccId: string;
}

export interface SsccActionsPayload {
  tripId: string; // the unique one, not reference id
  legId: string;
  manifestId: string;
  ssccId: string;
  sscc: SSCCProps | undefined;
}

export interface SsccActionsContext {
  trip: TripSheetProps;
  leg: ManifestLegProps;
  manifest: ManifestProps;
  transformedManifest: Manifest;
  ssccEntry: ManifestSSCC | undefined;
  tripDisplayStatus: TripLegStatus;
}

export type ASNOccurrences = Map<
  string,
  { ssccId?: string; manifestId?: string; tripId?: string; legIndex?: number; asn?: string; asnId?: string }[]
>;

export type SSCCOccurrences = Map<string, { manifestId?: string; tripId?: string; legIndex?: number }[]>;

export type ManifestOccurrences = Map<string, { tripId: string; legIndex: number }[]>;

export enum AdminActionType {
  // Manifest Actions
  SSCC_ADD_TO_MANIFEST = 'SSCC Add to Manifest',
  MANIFEST_COMPLETE = 'Manifest Complete',
  MANIFEST_DELETE = 'Manifest Delete',

  // SSCC Actions
  ASN_ASSIGN_TO_SSCC = 'ASN Assign to SSCC',
  SSCC_COMPLETE = 'SSCC Complete',
  SSCC_REMOVE_FROM_MANIFEST = 'SSCC Remove from Manifest',

  // ASN Actions
  ASN_REMOVE_FROM_SSCC = 'ASN Remove from SSCC',

  // Admin Panel Access
  ADMIN_PANEL_GRANT_ACCESS = 'Grant Access',
  ADMIN_PANEL_REVOKE_ACCESS = 'Revoke Access',

  UNKNOWN = 'Unknown Action'
}

export enum EntityType {
  Manifest = 'Manifest',
  SSCC = 'SSCC',
  ASN = 'ASN',
  Access = 'Access',
  UNKNOWN = 'Unknown Entity'
}

export interface AuditLogOptions {
  actionType: AdminActionType;
  beforeAction: any;
  afterAction: any;
  actionBy: string;
  reason?: string;
}

export interface AuditLog {
  id: string;
  timestamp: string;
  user: string;
  action: AdminActionType;
  entityType: EntityType;
  entityId: string;
  fullEntityId: string;
  changes: string;
  fullChanges: string;
  reason: string;
}

export interface BustleDialogData {
  message: string;
  messageDetail: string;
}
